import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools, Time } from '../../../services'

import { Headerbar, FormInput, ConfirmLink, ClickToCopy, YesNo, Loader, EditContainer, ImagesPicker } from '../../Reusable'

import Select from 'react-select'
import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

interface Props {
}
const PosterItem: React.FC<Props> = (props) => {
  
  const [error, setError] = React.useState('')
  const [item, setItem] = React.useState<any>(null)
  const [loading, setLoading] = React.useState(false)
  const [changed, setChanged] = React.useState(false)
  const [ads, setAds] = React.useState<any[]>([])
  
  const posterRef = Fire.store().collection('poster').doc('POSTER')
  
  React.useEffect(() => {
    load()
  }, [])

  const load = async () => {
    setLoading(true)
    try {
      setItem(await onFetch())
      setAds(await onFetchAds())
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
  }

  const onFetch = async () => {
    try {
      const doc = Fire.doc(posterRef)
      return doc
    } catch (err) {
      setError("Impossible de charger l'élément à l'affiche")
      console.warn(err)
    }
    return null
  }

   const onFetchAds = async () => {
    try {
      let ref: any = Fire.store().collection('ads')
        .orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      for (const item of list) {
        item.label = item.name
        item.value = item.id
      }
      return list
    } catch (err) {
      setError("Impossible de charger les catégories")
      console.warn(err)
    }
    return []
  }

  const onChange = (newItem: any) => {
    setItem(newItem)
    setChanged(true)
  }

  const onRemove = async () => {
    const confirm = window.confirm("Êtes-vous sûr de vouloir vider l'affiche ?")
    if (!confirm)
      return;
    try {
      await posterRef.delete()
      setItem(null)
    } catch (err) {
      setError("Impossible de charger l'élément à l'affiche")
      console.warn(err)
    }
  }

  const onSave = async () => {
    setLoading(true)
    try {
      await posterRef.set(item)      
      setChanged(false)
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
  }

  return (
    <React.Fragment>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Poster actif</h3>
        </div>
        <div className="card-body">

          {loading ? (
            <div>Chargement...</div>
          ) : item ? (
            <div>
              <div className="table-preview">
                {item.pictures && item.pictures.length > 0 &&
                  <img alt={item.name} src={item.pictures[0]} />
                }
              </div>
              <div>Name: {item.name}</div>
            </div>
          ) : (
            <div>Aucun élément à l'affiche</div>
          )}

          { item && !changed &&
            <div className="centered">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={onRemove}
                disabled={loading}
                >
                { loading ? 'Chargement...' : "Vider l'affiche" }
              </button>
            </div>
          }
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Choisir un nouveau poster</h3>
        </div>
        <div className="card-body">
          <div className="item-add-form">

            <Select
              disabled={loading}
              value={item}
              onChange={onChange}
              options={ads}
            />
          </div>

          <div className="centered">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={onSave}
              disabled={loading|| !changed}
              >
              { loading ? 'Chargement...' : 'Enregistrer' }
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PosterItem
